import { FormatListBulleted, Search, SwapVert } from "@mui/icons-material";
import FullWidthButton from "./FullWidthButton";



export default function SyncTranscriptAudio({
    bottom,
    scrollToCurrentMessage,
    onSyncClick,
    track,

    // Optional.
    onSearchClick,
    onSectionsClick,
}) {
    const shouldHideControl = !track || scrollToCurrentMessage;

    return (
        <div className='syncButtonContainerBottom'
            aria-hidden={shouldHideControl}
            inert={shouldHideControl ? '' : undefined}
            style={
            shouldHideControl ? {
                // Hide by moving above.
                // Using visibility and display to hide causes scrollIntoView to be interrupted in Chrome.
                position: 'fixed',
                top: '-5000px'
            } : {
                bottom: bottom,
            }
        }>
            <FullWidthButton
                Icon={SwapVert}
                title='Follow audio'
                onClick={onSyncClick}
                showChevron={false}
                contentGap='8px'
                iconStyle={{ fontSize: '18px', verticalAlign: 'middle' }}
                containerStyle={{ width: 'auto', pointerEvents: 'auto' }}
                buttonStyle={{ width: 'auto', pointerEvents: 'auto' }}
                buttonClassName='previewFloatingButton previewAutoScrollButton'
                iconShellClassName='previewFloatingButtonIconShell'
                textClassName='previewFloatingButtonText'
            />

            {onSearchClick && (
                <button className='syncButton'
                    onClick={() => {
                        onSearchClick();
                    }}>
                    <div className='syncButtonDiv'>
                        <div style={{ width: '46px' }}>
                            <Search style={{ fontSize: '22px', verticalAlign: 'middle' }} />
                        </div>
                    </div>
                </button>
            )}

            {onSectionsClick && (
                <button className='syncButton'
                    onClick={() => {
                        onSectionsClick();
                    }}>
                    <div className='syncButtonDiv'>
                        <div style={{ width: '46px' }}>
                            <FormatListBulleted style={{ fontSize: '22px', verticalAlign: 'middle' }} />
                        </div>
                    </div>
                </button>
            )}
        </div>
    );
}
